import Vue from "vue";
import VueRouter from "vue-router";
import AuthLayout from "@/layouts/Auth";
import Login from "@/views/auth/Login";
import i18n from "@/i18n";
import AdminLayout from "@/layouts/Admin";
import Dashboard from "@/views/Dashboard";
import Error from "@/views/Error";
import Slide from "@/views/Slide/index";
import AboutUs from "@/views/AboutUs/index";
import Award from "@/views/Award/index";
import BusinessGroup from "@/views/BusinessGroup/index";
import News from "@/views/News/index";
import CEO from "@/views/CEO/index";
import ContactUS from "@/views/ContactUS/index";
import Landing from "@/views/Landing/index";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
    component: AuthLayout,
    children: [
      {
        path: "/admin/login",
        name: "Login",
        component: Login,
        meta: {
          title: i18n.t("routes.login"),
        },
      },
    ],
  },{
    path: '/',
    component: AdminLayout,
    meta: {
      title: i18n.t("routes.home"),
    },
    children: [
      {
        path: "/admin/dashboard/:lang",
        name: "dashboard",
        component: Dashboard,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/slide/:lang",
        name: "Slide",
        component: Slide,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/aboutus/:lang",
        name: "AboutUs",
        component: AboutUs,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/award/:lang",
        name: "Award",
        component: Award,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/businessgroup/:lang",
        name: "BusinessGroup",
        component: BusinessGroup,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/news/:lang",
        name: "News",
        component: News,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/ceo/:lang",
        name: "CEO",
        component: CEO,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/contactus/:lang",
        name: "ContactUS",
        component: ContactUS,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "/admin/landing/:lang",
        name: "Landing",
        component: Landing,
        meta: {
          title: i18n.t("routes.dashboard"),
        },
      },
      {
        path: "*",
        component: Error,
        meta: {
          title: i18n.t("routes.not_found"),
        },
      },
    ],
  }
];
import store from "../store";
export default new VueRouter({
  mode: "history",
  base: store.getters.base_url_route,
  routes,
});
